export default [
  {
    text: 'Medicare Supplement',
    value: '/medicare-supplement/save-money'
  },
  {
    text: 'Medicare Advantage',
    value: '/medicare-advantage/save-money'
  },
  {
    text: 'Life Insurance',
    value: '/life-insurance/save-money-on-life-insurance'
  },
  {
    text: 'Guaranteed Issue',
    value: '/life-insurance/guaranteed-issue'
  },
  {
    text: 'Disability Insurance',
    value: '/disability-insurance/save-money'
  }
]
